const KEY = 'aimmo.sidebar.collapsed';

/**
 * The sidebar's collapsed state, stored the way the theme is: a plain
 * localStorage read behind a try/catch, because private mode must degrade to a
 * working screen rather than a crash (`@aimmo/ui/theme-mode.ts`).
 */
export function storedCollapsed(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
}

export function storeCollapsed(next: boolean): void {
  try {
    localStorage.setItem(KEY, String(next));
  } catch {
    // The choice does not survive the reload; this session is still correct.
  }
}
